@if(visibleImages.length > 0) {
  <div class="mosaic-container"  [class]="'mosaic-container thumbnail-' + thumbnailSize">
    <div class="mosaic-grid" [attr.data-count]="visibleImages.length">
      @for(medium of visibleImages; let i = $index; track medium.fileId) {
        <div class="mosaic-item"
          [class.has-overlay]="i === visibleImages.length - 1 && remainingCount > 0"
          (click)="onImageClick(medium.fileId)">
          <img [src]="medium.fileId| httpImgSrc" [alt]="medium.originalname" loading="lazy" />

          @if(i === visibleImages.length - 1 && remainingCount > 0) {
            <div class="overlay" >
              <span class="remaining-text">+{{remainingCount}}</span>
            </div>
          }  
        </div>
      }
    </div>
  </div>
}
